<section class="hero" [ngClass]="{
    'hero-ar': translateService.currentLang === 'ar',
    'hero-en': translateService.currentLang !== 'ar'
  }">
  <div class="container h-100 d-flex flex-column justify-content-center" *ngIf="complexInfo$ | async as complexInfo">
    <h1>{{ translateService.currentLang === 'en' ? complexInfo?.nameEN : complexInfo?.name }}</h1>
    <p>{{ translateService.currentLang === 'en' ? complexInfo?.descriptionEN : complexInfo?.description }}</p>
    <div class="d-flex align-items-center">

    </div>
  </div>
</section>

<section class="custom__home__numbers" *ngIf="statistics$ | async as stats">
  <div class="container">
    <div class="custom__home__header">
      <div class="custom__home__header__top">
        <h2 class="custom__home__header__title">
          {{ translateService.currentLang === 'en' ? 'Statistics' : 'إحصائيات' }}
        </h2>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="custom__home__numbers__items row">
      
      <div class="col-6 col-lg-3">
        <div class="custom__home__numbers__items__item">
          <div class="custom__home__numbers__items__item__icon">
            <img src="/media/images/stats-icons/elements3.svg" alt="Qurans" loading="lazy" decoding="async" width="28" height="28" />
          </div>
          <div class="custom__home__numbers__items__item__text">
            <h3 class="custom__home__numbers__items__item__text__title">
              <span *ngIf="translateService.currentLang === 'en'">+</span>
              {{ stats.quran }}
              <span *ngIf="translateService.currentLang !== 'en'">+</span>
            </h3>
            <p class="custom__home__numbers__items__item__text__subtitle">
              {{ translateService.currentLang === 'en' ? 'Qurans' : 'المصاحف' }}
            </p>
          </div>
        </div>
      </div>
      
      <div class="col-6 col-lg-3">
        <div class="custom__home__numbers__items__item">
          <div class="custom__home__numbers__items__item__icon">
            <img src="/media/images/stats-icons/elements1.svg" alt="Rare Books" loading="lazy" decoding="async" width="28" height="28" />
          </div>
          <div class="custom__home__numbers__items__item__text">
            <h3 class="custom__home__numbers__items__item__text__title">
              <span *ngIf="translateService.currentLang === 'en'">+</span>
              {{ stats.rareBook }}
              <span *ngIf="translateService.currentLang !== 'en'">+</span>
            </h3>
            <p class="custom__home__numbers__items__item__text__subtitle">
              {{ translateService.currentLang === 'en' ? 'Rare Books' : 'الكتب النادرة' }}
            </p>
          </div>
        </div>
      </div>
      
      <div class="col-6 col-lg-3">
        <div class="custom__home__numbers__items__item">
          <div class="custom__home__numbers__items__item__icon">
            <img src="/media/images/stats-icons/elements4.svg" alt="Manuscripts" loading="lazy" decoding="async" width="28" height="28" />
          </div>
          <div class="custom__home__numbers__items__item__text">
            <h3 class="custom__home__numbers__items__item__text__title">
              <span *ngIf="translateService.currentLang === 'en'">+</span>
              {{ stats.manuScript }}
              <span *ngIf="translateService.currentLang !== 'en'">+</span>
            </h3>
            <p class="custom__home__numbers__items__item__text__subtitle">
              {{ translateService.currentLang === 'en' ? 'Manuscripts' : 'المخطوطات' }}
            </p>
          </div>
        </div>
      </div>
      
      <div class="col-6 col-lg-3">
        <div class="custom__home__numbers__items__item">
          <div class="custom__home__numbers__items__item__icon">
            <img src="/media/images/stats-icons/elements2.svg" alt="Valuable Collections" loading="lazy" decoding="async" width="28" height="28" />
          </div>
          <div class="custom__home__numbers__items__item__text">
            <h3 class="custom__home__numbers__items__item__text__title">
              <span *ngIf="translateService.currentLang === 'en'">+</span>
              {{ stats.valuableCollection }}
              <span *ngIf="translateService.currentLang !== 'en'">+</span>
            </h3>
            <p class="custom__home__numbers__items__item__text__subtitle">
              {{ translateService.currentLang === 'en' ? 'Valuable Collections' : 'المقتنيات الثمينة' }}
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<section class="platform-features" *ngIf="complexInfo$ | async as complexInfo">
  <div class="container py-4">
    <h2 class="mb-5 fw-bold" style="color: var(--Text-text-display, #1f2a37);" [ngClass]="translateService.currentLang === 'ar' ? 'text-end' : 'text-center'" [dir]="translateService.currentLang === 'ar' ? 'rtl' : 'ltr'">
      {{ translateService.currentLang === 'en' ? 'Features of the Holy Quran Platform' : 'مميزات منصة المصحف الشريف' }}
    </h2>
    <div class="platform-features__image text-center" *ngIf="complexInfo?.hierarchy">
      <img [src]="environment.baseUrl + '/Files/' + complexInfo.hierarchy" 
           alt="Platform Features" 
           loading="lazy" 
           decoding="async" 
           width="1110" 
           height="564"
           class="img-fluid" />
    </div>
  </div>
</section>


<!-- <section class="container">
  <div class="section-header">
    <h2 translate="home.topLibraries"></h2>
    <a routerLink="/libraries" class="btn_secondary btn-view-all" translate="home.viewAll"></a>
  </div>
  <div class="global-cards-row home mobile-scroll-row" *ngIf="topLibraries$ | async as libraries">
    <div class="global-cards-row__container" *ngFor="let lib of libraries">
      <app-libraries-card [library]="lib" />
    </div>
  </div>
</section> -->

<section class="with-bgc pb-5 pt-5">
  <div class="container">
    <div class="section-header">
      <h2 translate="home.quranDecorations"></h2>
      <a routerLink="/quran-decorations" class="btn_secondary btn-view-all" translate="home.viewAll"></a>
    </div>
    <div class="global-cards-row home mobile-scroll-row" *ngIf="quranDecorations$ | async as decorations">
      <div class="global-cards-row__container" *ngFor="let dec of decorations">
        <div class="global-card">
          <img loading="lazy" class="community_img" [src]="dec.imageUrl ? (dec.imageUrl.startsWith('http') ? dec.imageUrl : (environment.baseUrl + '/Files/' + dec.imageUrl)) : '/media/images/custom/defualt-img.jpg'" [alt]="dec.nameAR" onerror="this.src='/media/images/custom/defualt-img.jpg'" />
          <div class="texts">
            <h3>{{ translateService.currentLang === 'en' ? dec.nameEN : dec.nameAR }}</h3>
            <p class="description">
              {{ translateService.currentLang === 'en' ? dec.descEN : dec.descAR }}
            </p>
          </div>
          <div class="buttons justify-content-start">
            <button [routerLink]="['/quran-decorations-quran', dec.id]" class="btn-primary without-min" translate="READ_MORE"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="container mt-5 mb-5">
  <div class="section-header">
    <h2 translate="home.timePeriods"></h2>
    <a routerLink="/time-periods" class="btn_secondary btn-view-all" translate="home.viewAll"></a>
  </div>
  <div class="global-cards-row home mobile-scroll-row" *ngIf="timePeriods$ | async as timePeriods">
    <div class="global-cards-row__container" *ngFor="let period of timePeriods">
      <div class="global-card">
        <img loading="lazy" class="community_img" [src]="period.imageUrl ? (period.imageUrl.startsWith('http') ? period.imageUrl : (environment.baseUrl + '/Files/' + period.imageUrl)) : '/media/images/custom/defualt-img.jpg'" [alt]="period.nameAR" onerror="this.src='/media/images/custom/defualt-img.jpg'" />
        <span class="card-tag" *ngIf="period.dateFrom || period.dateTo">
          {{ formatHijriYear(period.dateFrom) }} <ng-container *ngIf="period.dateFrom && period.dateTo">-</ng-container> {{ formatHijriYear(period.dateTo) }}
        </span>
        <div class="texts">
          <h3>{{ translateService.currentLang === 'en' ? period.nameEN : period.nameAR }}</h3>
          <p class="description">
            {{ translateService.currentLang === 'en' ? period.descEN : period.descAR }}
          </p>
        </div>
        <div class="buttons justify-content-start">
          <button [routerLink]="['/time-periods-quran', period.id]" class="btn-primary without-min" translate="READ_MORE"></button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Quran Calligraphies Section -->
<section class="with-bgc pb-5 pt-5">
  <div class="container">
      <div class="section-header">
    <h2 translate="home.quranCalligraphies"></h2>
    <a routerLink="/quran-calligraphies" class="btn_secondary btn-view-all" translate="home.viewAll"></a>
  </div>
  <div class="global-cards-row home mobile-scroll-row" *ngIf="quranCalligraphies$ | async as calligraphies">
    <div class="global-cards-row__container" *ngFor="let cal of calligraphies">
      <div class="global-card">
        <img loading="lazy" class="community_img" [src]="cal.imageUrl ? (cal.imageUrl.startsWith('http') ? cal.imageUrl : (environment.baseUrl + '/Files/' + cal.imageUrl)) : '/media/images/custom/defualt-img.jpg'" [alt]="cal.nameAR" onerror="this.src='/media/images/custom/defualt-img.jpg'" />
        <div class="texts">
          <h3>{{ translateService.currentLang === 'en' ? cal.nameEN : cal.nameAR }}</h3>
          <p class="description">
            {{ translateService.currentLang === 'en' ? cal.descEN : cal.descAR }}
          </p>
        </div>
        <div class="buttons justify-content-start">
          <button [routerLink]="['/quran-calligraphies-quran', cal.id]" class="btn-primary without-min" translate="READ_MORE"></button>
        </div>
      </div>
    </div>
  </div>
  </div>
</section>


<!-- Starts : Footer -->
<app-footer></app-footer>
<!-- Ends : Footer -->